/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Detail_Stats_Total_MembersInputs */



/**
* | output |
* | --- |
* | "Team Members" |
*
* @param {Teams_Detail_Stats_Total_MembersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_detail_stats_total_members = /** @type {((inputs?: Teams_Detail_Stats_Total_MembersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Detail_Stats_Total_MembersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teammitglieder")
	return /** @type {LocalizedString} */ ("Team Members")
});